import { PALLETTE } from "../utils/theme";

export const V2ReportStyle: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: "flex",
    backgroundColor: PALLETTE.background,
    flexDirection: "column",
    gap: "1rem",
    borderWidth: "3px",
    borderStyle: "solid",
    borderColor: PALLETTE.bgBlue,
    // paddingBottom: "1rem",
    borderRadius: "10px",
  },

  mainContainer: {
    flex: 1,
    display: "flex",
    backgroundColor: PALLETTE.white,
    flexDirection: "column",
    overflowY: "scroll",
    margin: 0,
  },
  card: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: PALLETTE.white,
    borderRadius: "0.625rem",
    padding: "2rem",
  },
  suggestedCard: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    backgroundColor: PALLETTE.white,
    borderRadius: "0.625rem",
    padding: "1rem",
  },
  carouselCard: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.625rem",
    alignItems: "center",
  },
  cardWithBg: {
    backgroundColor: PALLETTE.background,
    borderRadius: "0.75rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
  },
  dot: {
    width: "1.5rem",
    height: "1.5rem",
    borderRadius: "50%",
    borderWidth: "2px",
    borderStyle: "solid",
  },
  point: {
    width: "1rem",
    height: "1rem",
    borderRadius: "50%",
    backgroundColor: PALLETTE.dark,
  },
  flexRowCenter: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  flexColumnCenter: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  label: {
    alignContent: "center",
    backgroundColor: PALLETTE.greenShade1,
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingTop: "0.125rem",
    paddingBottom: "0.125rem",
    borderRadius: "6.25rem",
  },
  modalBox: {
    backgroundColor: PALLETTE.white,
    borderRadius: "1rem",
    zIndex: 99,
  },
  logoDimension: {
    height: "10rem",
    width: "10rem",
    objectFit: "contain",
  },
  signDimension: {
    height: "1.25rem",
    width: "4.7rem",
    objectFit: "fill",
  },
  hospitalLogoDimension: {
    height: "10rem",
    width: "15rem",
    objectFit: "contain",
  },
  docSignImg: {
    height: "5rem",
    width: "100%",
    objectFit: "contain",
  },
  checkBox: {
    height: "2rem",
    width: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #000",
    backgroundColor: PALLETTE.white,
    borderRadius: "0.5rem",
  },
  eyeBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0.625rem",
    backgroundColor: PALLETTE.white,
    padding: "2rem",
  },
  shadow: {
    backgroundColor: PALLETTE.white,
    boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.25)",
  },
  closeRoundButton: {
    height: "3.1rem",
    width: "3.1rem",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid" + PALLETTE.chip,
    zIndex: 100,
  },
  bmiUser: {
    height: "full",
    width: "5rem",
    objectFit: "contain",
  },
  bmiUserContainer: {
    borderRadius: "0.625rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    width: "11rem",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  measurebox: {
    border: "1px solid #000",
    borderRadius: "0.625rem",
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem",
    paddingLeft: "0.6rem",
    paddingRight: "0.6rem",
  },
  scrollViewStyle: {
    backgroundColor: PALLETTE.background,
    overflowY: "auto",
  },
  skeleton: {
    width: "92%",
    height: "9.3rem",
    borderRadius: "0.625rem",
  },
  bannerSkeleton: {
    width: "92%",
    height: "4.3rem",
    borderRadius: "0.625rem",
    marginTop: "1rem",
  },
  spinnerStyle: {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #3b82f6",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};
